import './storeSegmentInformation.scss';
import InfoPanel from '@/components/common/InfoPanel/InfoPanel';
import { convertUnixTimestamp } from '@/helpers/convertUnixTimestamp';
import { DataTable } from 'pepsico-ds';

export default function SegmentInformation ({ storeData }) {
  const columns = [
    {
      columnKey: 'name',
      header: 'SEGMENT NAME',
      cellData: ctx => {
        return (
          <p className='cursor-pointer text-[#3387DF] font-bold' onClick={() => {}}>{ctx.row.original.name}</p>
        )
      },
    },
    {
      columnKey: 'description',
      header: 'DESCRIPTION',
      cellData: ctx => {
        return ctx.row.original.description || '-';
      }
    },
    {
      columnKey: 'creationDate',
      header: 'CREATION DATE',
      cellData: ctx => {
        return convertUnixTimestamp(ctx.row.original.creationDate);
      }
    }
  ];


  // Ensure we always have an array, even if segments is undefined
  const segmentsData = storeData.segments || [];

  return (
    <InfoPanel
      title='Segments'
      isCollapsible={true}
      defaultOpen={true}
      className='mt-4'>
      <div className='admin-profile_segments-table-container'>
        <DataTable
          tableHeader=''
          tableDescription=''
          showGlobalActions={false}
          columns={columns}
          data={segmentsData}
          pageSize={500}
        />
      </div>
    </InfoPanel>
  );
}
